/**
 * Default value for the data accumulator React context.
 * @module dataAccumulator/defaultContextValue
 */
import { DataAccumulatorContextValue, DomainFetcher } from "./types";

/** No-op domain fetcher used in the default context value. */
export const noopFetcher: DomainFetcher = async () => ({
  success: true,
  data: null,
  error: null,
});

/** Default context value before the provider mounts. */
export const defaultDataAccumulatorContextValue: DataAccumulatorContextValue = {
  generalOrderDetails: null,
  generalOrderDetailsLoading: false,
  generalOrderDetailsError: null,
  fetchGeneralOrderDetails: noopFetcher,

  authOnFileDetails: null,
  authOnFileDetailsLoading: false,
  authOnFileDetailsError: null,
  fetchAuthOnFileDetails: noopFetcher,

  clinicalData: null,
  clinicalDataLoading: false,
  clinicalDataError: null,
  fetchClinicalData: noopFetcher,

  commentsData: null,
  commentsDataLoading: false,
  commentsDataError: null,
  fetchCommentsData: noopFetcher,

  coverageDetails: null,
  coverageDetailsLoading: false,
  coverageDetailsError: null,
  fetchCoverageDetails: noopFetcher,

  workflowConfig: null,
  workflowConfigLoading: false,
  workflowConfigError: null,
  fetchWorkflowConfig: noopFetcher,

  reviewsData: null,
  reviewsDataLoading: false,
  reviewsDataError: null,
  fetchReviewsData: noopFetcher,

  clinicalConditions: null,
  clinicalConditionsLoading: false,
  clinicalConditionsError: null,
  fetchClinicalConditions: noopFetcher,

  authorizationData: null,
  authorizationDataLoading: false,
  authorizationDataError: null,
  fetchAuthorizationData: noopFetcher,

  submissionData: null,
  submissionDataLoading: false,
  submissionDataError: null,
  fetchSubmissionData: noopFetcher,

  siblingOrders: null,
  siblingOrdersLoading: false,
  siblingOrdersError: null,
  fetchSiblingOrders: noopFetcher,

  denialQueryBucketData: null,
  denialQueryBucketLoading: false,
  denialQueryBucketError: null,
  fetchDenialQueryBucket: async () => ({
    success: true,
    data: null,
    error: null,
  }),

  candidHistoryWriteback: null,
  candidHistoryWritebackLoading: false,
  candidHistoryWritebackError: null,
  fetchCandidHistoryWriteback: noopFetcher,

  filteredSiblingOrders: null,
  recomputeFilteredSiblingOrders: () => {},

  loading: false,
  fetchAll: async () => {},
  abortAll: () => {},
  resetAll: () => {},

  selectedSiblingOrderIds: [],
  setSelectedSiblingOrderIds: () => {},
  isSiblingOrderSelectionDisabled: false,
  setIsSiblingOrderSelectionDisabled: () => {},
};
